import styled from 'styled-components';
import { colors, colorAliases } from '../../../../variables/colors.js';
import { deviceWidths } from '../../../../variables/widths.js';
import { fonts } from '../../../../variables/fonts.js';

var HotelHitContentFooterContainer = styled.div.withConfig({
  displayName: "hotelHitContentFooter__HotelHitContentFooterContainer",
  componentId: "sc-185m96h-0"
})(["background:", ";padding:4px 8px;display:flex;flex-direction:column;align-items:flex-end;font-size:14px;justify-content:space-between;position:relative;text-align:right;@media (min-width:", "){align-items:stretch;display:flex;flex-direction:row;font-size:inherit;min-height:80px;padding:8px 10px;text-align:left;z-index:1;}"], colors.extraLightGray, deviceWidths.tablet);
var ContentContainer = styled.div.withConfig({
  displayName: "hotelHitContentFooter__ContentContainer",
  componentId: "sc-185m96h-1"
})(["display:flex;flex:1 1 0%;flex-direction:row;width:100%;@media (min-width:", "){margin-right:10px;width:auto;}.sg-hotel-hit__icon{color:", ";padding-left:8px;margin-right:-4px;align-self:center;height:22px;width:22px;@media (min-width:", "){display:none;}}"], deviceWidths.tablet, colorAliases.text, deviceWidths.tablet);
var CTAContainer = styled.div.withConfig({
  displayName: "hotelHitContentFooter__CTAContainer",
  componentId: "sc-185m96h-2"
})(["align-items:center;display:flex;justify-content:center;.sg-hotel-hit__primary-button{display:none;@media (min-width:", "){display:inline-flex;}}"], deviceWidths.tablet);
var InfoSection = styled.div.withConfig({
  displayName: "hotelHitContentFooter__InfoSection",
  componentId: "sc-185m96h-3"
})(["display:flex;flex:1 0 auto;flex-direction:column;text-align:left;justify-content:center;@media (min-width:", "){border-right:1px solid ", ";padding-right:8px;padding-left:6px;}.sg-hotel-hit__arrow-link{display:none;white-space:nowrap;@media (min-width:", "){font-size:14px;display:inline-block;margin-left:1px;svg{font-size:10px;width:1em;height:1em;}}}"], deviceWidths.tablet, colors.lightGray, deviceWidths.tablet);
var InfoLabel = styled.span.withConfig({
  displayName: "hotelHitContentFooter__InfoLabel",
  componentId: "sc-185m96h-4"
})(["color:", ";font-size:14px;line-height:18px;"], colors.darkGrayL1);
var NoPriceSection = styled(InfoSection).withConfig({
  displayName: "hotelHitContentFooter__NoPriceSection",
  componentId: "sc-185m96h-5"
})(["flex:1 1 0%;"]);
var PriceSection = styled.div.withConfig({
  displayName: "hotelHitContentFooter__PriceSection",
  componentId: "sc-185m96h-6"
})(["align-items:center;display:flex;padding-left:4px;@media (min-width:", "){flex:1 0 auto;border-right:1px solid ", ";padding-left:8px;padding-right:8px;}"], deviceWidths.tablet, colors.lightGray);
var PriceInfoText = styled.div.withConfig({
  displayName: "hotelHitContentFooter__PriceInfoText",
  componentId: "sc-185m96h-7"
})(["color:", ";font-size:14px;margin-bottom:2px;"], colors.darkGrayL1);
var OriginalPrice = styled.div.withConfig({
  displayName: "hotelHitContentFooter__OriginalPrice",
  componentId: "sc-185m96h-8"
})(["text-decoration:line-through;margin-bottom:2px;"]);
var CurrentPrice = styled.div.withConfig({
  displayName: "hotelHitContentFooter__CurrentPrice",
  componentId: "sc-185m96h-9"
})(["font-family:", ";font-size:23px;color:", ";@media (min-width:", "){font-size:28px;}"], fonts.bold, function (props) {
  return props.isDiscount ? colors.rouge : 'inherit';
}, deviceWidths.tablet);
var PricePerPerson = styled.div.withConfig({
  displayName: "hotelHitContentFooter__PricePerPerson",
  componentId: "sc-185m96h-10"
})(["color:", ";font-size:14px;"], colors.darkGrayL1);

export { CTAContainer, ContentContainer, CurrentPrice, HotelHitContentFooterContainer, InfoLabel, InfoSection, NoPriceSection, OriginalPrice, PriceInfoText, PricePerPerson, PriceSection };
//# sourceMappingURL=hotelHitContentFooter.js.map
